import React from 'react';

interface AssetContext {
  setIsMouseInsideAsset: (value: boolean) => void;
  isMouseInsideAsset: boolean;
}

const AssetContext = React.createContext<AssetContext>(undefined!);

type Props = {
  children: React.ReactNode;
};

const AssetState = (props: Props) => {
  const [isMouseInsideAsset, setIsMouseInsideAsset] = React.useState(false);

  return (
    <AssetContext.Provider
      value={{
        isMouseInsideAsset,
        setIsMouseInsideAsset,
      }}
    >
      {props.children}
    </AssetContext.Provider>
  );
};

export { AssetContext, AssetState };
